import { css, cx } from '@emotion/css';
import { tabStyle,repeaterPaneStyle } from 'Shared/backend/contact/ContactPage';
import { theme } from 'Shared/backend/ThemeProvider';
import { Time } from 'Shared/forms/DateTimeInputs';
import { Checkbox, MultiSelect, Text } from 'Shared/forms/Inputs';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { LabelOnLeftWrap, Wrap } from 'Shared/forms/Wrap';
import { BusinessHoursEntry } from 'Shared/common/BusinessHoursEntry';
import { Match, Show, Switch } from 'solid-js';
import { dayLabels } from 'Shared/common/DayLabels';

const hoursTitleStyle = () => css({
	h5: {
		margin:0,
		fontSize:'1em',
		fontWeight:700
	}
});

// now taking date from OperatingHours repeater not old BusinessHours repeater 

// CJ added ability to make repeater a Section Heading to group hours

export function HoursTab(props)
{
	let hoursNode;

	return (
		<div class={cx(tabStyle(),hoursTitleStyle())}>
			<StoreRepeater ref={hoursNode} {...props} page={props.page} field='operatingHours'
				renderTitle={i => <BusinessHoursEntry {...i} /> }
			>
				{(item,index) => <HoursContent {...props} {...item} location={['operatingHours',index]} index={index} />}
			</StoreRepeater>

			<button class={css(theme().button,{alignSelf:'start'})}
				onClick={() => addItemAndOpen({...props,permission:'edit',field:'operatingHours'},hoursNode,{})}
			>
				<i class='fas fa-plus'/> Add social media
			</button>
		</div>
	);
}

function HoursContent(props)
{
	return (
		<div class={repeaterPaneStyle('1.2em')}>
			<LabelOnLeftWrap label='Create a heading to group hours under' required={true}
				notes='Eg "Bar", or "Kitchen Hours".'
			>
				<Checkbox {...props} field='createSectionHeading' />
			</LabelOnLeftWrap>

			<Switch>
				<Match when={props.createSectionHeading}>
					<Wrap label='Heading' notes='Case sensitive so type as you want it seen' >
						<Text {...props} field='sectionHeading' />
					</Wrap>
				</Match>
				<Match when={true}>
					<Wrap label='Select Day/s' notes='You can select multiple days that have identical opening and closing times'>
						<MultiSelect {...props} field='daysopen' options={dayLabels}/>
					</Wrap>

					<Show when={props.daysopen?.other}>
						{/* TODO consider moving otherDays into calendarEntry macro for your new 'times' field for things like Christmas Day */}

						<Wrap label='Other days' notes='Eg New Years Day'>
							<Text {...props} field='otherDays' />
						</Wrap>
					</Show>

					<LabelOnLeftWrap label='Opens (leave blank if closed all day)'>
						<Time {...props} field='opens' />
					</LabelOnLeftWrap>

					<LabelOnLeftWrap label='Closes (leave blank if until "late")'>
						<Time {...props} field='closes' />
					</LabelOnLeftWrap>

					<Wrap label='Custom Label' instructionsAfterLabel='This will display instead of the date & time format above'>
						<Text {...props} field='customLabel' />
					</Wrap>
				</Match>
			</Switch>
		</div>
	);
}

